import { useMemo } from 'react';
import { matchPath } from 'react-router-dom';
import useLiterals from 'utils/hooks/useLiterals';
import LogoImg from 'assets/logos/logo.png';
import LogoAndroid from 'assets/images/play-store.png';
import LogoApple from 'assets/images/app-store.png';
import { buttonClasses } from 'components/UI/Button';
import { APP_STORE_URL } from 'constants/global';
import { ROUTE_PATH } from 'routes';

const DownloadApp = () => {
  const literals = useLiterals('downloadApp');
  const openApp = useMemo(() => {
    return matchPath({ path: ROUTE_PATH.APP }, window.location.pathname);
  }, []);

  return (
    <div className='max-w-[300px] mx-auto my-6 px-2'>
      <img className='block mx-auto mt-2.5 mb-6' src={LogoImg} alt='Platform logo' />
      <h1 className='text-center mb-12 mt-12'>{openApp ? literals.hi : literals.title}</h1>
      <p className='mb-6'>{openApp ? literals.ifNotHaveOrNotOpen : literals.available}</p>
      {/* Anchors reales: las URLs de tienda son externas y RR Link no navega fuera del SPA. */}
      <a
        href={APP_STORE_URL.ANDROID}
        target='_blank'
        rel='noreferrer'
        className={buttonClasses('secondary', 'md', 'mb-6 flex items-center justify-center gap-2.5')}
      >
        <img src={LogoAndroid} alt='Platform logo' className='h-[30px] w-auto' />
        Play Store
      </a>
      <a
        href={APP_STORE_URL.IOS}
        target='_blank'
        rel='noreferrer'
        className={buttonClasses('secondary', 'md', 'flex items-center justify-center gap-2.5')}
      >
        <img src={LogoApple} alt='Platform logo' className='h-[30px] w-auto' />
        App Store
      </a>
    </div>
  );
};

export default DownloadApp;
